import React from "react";
import { motion } from "framer-motion";

/**
 * MaskedLines — renders a headline where each line is inside overflow-hidden
 * and the inner text animates from translateY(100%) to 0 with staggered delays.
 * Pass an array of strings.
 */
export function MaskedLines({
    lines,
    className = "",
    lineClassName = "",
    delay = 0,
    stagger = 0.12,
    duration = 1.0,
    as: Tag = "h1",
}) {
    return (
        <Tag className={className}>
            {lines.map((line, i) => (
                <span key={i} className={`mask-line ${lineClassName}`}>
                    <motion.span
                        className="inline-block will-change-transform"
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration,
                            delay: delay + i * stagger,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}

/**
 * FadeUp — reveal on view with subtle upward motion.
 */
export function FadeUp({ children, delay = 0, className = "", y = 32 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{
                duration: 0.9,
                delay,
                ease: [0.16, 1, 0.3, 1],
            }}
        >
            {children}
        </motion.div>
    );
}
